module.exports = "<div class=\"version-app-content\">\n    <p>Version: {{ version }}</p>\n</div>\n"